import { AttendanceCustomPeriodEmployeeItemFragment } from 'generated/resources/graphql'

import { i18nDateToString } from 'modules/core/lib/dates'

import { useBulkApprovePeriod } from 'modules/attendance/components/TimeTrackingCollection/hooks/useBulkApprovePeriod'

interface UseEmployeeApprovalParams {
  employee: AttendanceCustomPeriodEmployeeItemFragment
  cycle: string
  dateFrom: Date
  dateTo: Date
  onEmployeeUpdate?: (updatedEmployee: AttendanceCustomPeriodEmployeeItemFragment) => void
}

export const useEmployeeApproval = ({
  employee,
  cycle,
  dateFrom,
  dateTo,
  onEmployeeUpdate,
}: UseEmployeeApprovalParams) => {
  const { bulkApprovePeriod, bulkDisapprovePeriod } = useBulkApprovePeriod({
    cycle,
    startOn: i18nDateToString(dateFrom, 'backend'),
    endOn: i18nDateToString(dateTo, 'backend'),
  })

  const handleApprove = async () => {
    const refetchResult = await bulkApprovePeriod([employee.id?.toString() ?? ''])
    if (!refetchResult || !refetchResult[1]) return

    const result = refetchResult[1]
    if (!result?.data?.attendance?.customPeriodEmployeesConnection?.nodes) return

    const updatedEmployee = result.data.attendance.customPeriodEmployeesConnection.nodes.find(
      (node: AttendanceCustomPeriodEmployeeItemFragment) => node.id === employee.id
    )

    updatedEmployee && onEmployeeUpdate?.(updatedEmployee)
  }

  const handleDisapprove = async () => {
    const refetchResult = await bulkDisapprovePeriod([employee.id?.toString() ?? ''])
    if (!refetchResult || !refetchResult[1]) return

    const result = refetchResult[1]
    if (!result?.data?.attendance?.customPeriodEmployeesConnection?.nodes) return

    const updatedEmployee = result.data.attendance.customPeriodEmployeesConnection.nodes.find(
      (node: AttendanceCustomPeriodEmployeeItemFragment) => node.id === employee.id
    )

    updatedEmployee && onEmployeeUpdate?.(updatedEmployee)
  }

  return {
    handleApprove,
    handleDisapprove,
  }
}
